import { Box, Card, InputLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../Layout/Loader/Loaders";
import axios from "axios";
import { Url } from "../../constants";
import Energia from "../../assets/ENERGIA.svg"
import Luz from "../../assets/LUZ.svg"
import Urbanismo from "../../assets/URBANISMO.svg"
import Movilidad from "../../assets/MOVILIDAD.svg"
import ELUM from "../../assets/ELUM ICONOS.svg"

const HomeModuls = () => {

    const token = localStorage.getItem("token")
    const [charging, setcharging] = useState(false)
    const Navigate = useNavigate()
    const [Modulos, setModulos] = useState([])

    const getModulos = async () => {
        setcharging(true)

        await axios.get(Url + "GetCatalogos", {
            headers: {
                Authorization: token
            }
        })
        .then(res => {
            setcharging(false)
            setModulos(res.data.Catalogos)
        })
        .catch(err => {
            setcharging(false)
            console.log(err)
        })
    }

    useEffect(() => {
        if (token && !["null", "undefined"].includes(token)) {
            getModulos()
        } else {
            Navigate("/login")
        }
    },[])

    const changeIcon = (acronimo) => {
        switch (acronimo) {
            case "Energía":
                return <Box component="img" src={Energia} sx={{width:"30%"}} />;

            case "Luz":
                return <Box component="img" src={Luz} sx={{width:"30%"}} />;

            case "Urbanismo":
                return <Box component="img" src={Urbanismo} sx={{width:"30%"}} />;

            case "Movilidad":
                return <Box component="img" src={Movilidad} sx={{width:"30%"}} />;

            case "ELUM":
                return <Box component="img" src={ELUM} sx={{width:"80%"}} />;
        
            default:
                break;
        }
    }

    const goFiles = (modulo_select) => {
        const JsonModul = {
            "id_modul":modulo_select.id,
            "name_modul":modulo_select.catalogo_modulo
        }

        localStorage.setItem("modulo", JSON.stringify(JsonModul))
        Navigate("/archivos")
    }

    return (
        <>
        <Box sx={{display:"flex", justifyContent:"center", height:"100vh", alignItems:"center",
            background:"linear-gradient(to bottom right, #3F5AE9, #990089, #90FF3C, #F4D934);", 
            opacity:"90%",
        }}>
            <Box sx={{width:"80%"}}>
                <h1 style={{color:"white", fontSize:"70px"}}>Módulos</h1>

                <div style={{display:"flex", overflowY:"auto", height:"80vh", gap:30, paddingTop:"10vh",
                    flexWrap:"wrap", alignItems:"flex-start", justifyContent:"center"}} >
                    <style>
                        {`::-webkit-scrollbar {
                            width: 0px;
                        }`}
                    </style>
                    {Modulos.map((modulo, indexModulo) => (
                        <Card key={indexModulo} sx={{display:"flex", alignItems:"center", justifyContent:"center",
                            height:{md:"200px", xl:"250px"}, gap:2, borderRadius:5, flexDirection:"column",
                            ":hover":{backgroundColor:"#eaeded", cursor:"pointer"}
                        }} onClick={() => goFiles(modulo)}>
                            {changeIcon(modulo.catalogo_modulo)}
                            <InputLabel sx={{fontSize:"40px"}}>{modulo.catalogo_modulo}</InputLabel>
                        </Card>
                    ))}
                </div>
            </Box>
        </Box>

        {charging && <Loader />}
        </>
    )
}

export default HomeModuls;